import api, { API } from "./api";

const DEFAULT_CHUNK = 4 * 1024 * 1024; // 4 MB
export const MAX_MEDIA_BYTES = 20 * 1024 * 1024; // 20 MB

// Upload a File in chunks. `opts`: { contextType, entityId, isPublic, title, description, onProgress }
export async function uploadMedia(file, opts = {}) {
  const {
    contextType = "library",
    entityId = null,
    isPublic = false,
    title = null,
    description = null,
    onProgress = () => {},
  } = opts;

  if (file.size > MAX_MEDIA_BYTES) {
    throw new Error("File exceeds the 20 MB limit.");
  }

  const initRes = await api.post("/media/upload/init", {
    filename: file.name,
    content_type: file.type || "application/octet-stream",
    size: file.size,
    context_type: contextType,
    entity_id: entityId,
    is_public: isPublic,
    title,
    description,
  });
  const uploadId = initRes.data.upload_id;
  const chunkSize = initRes.data.chunk_size || DEFAULT_CHUNK;
  const totalChunks = Math.max(1, Math.ceil(file.size / chunkSize));

  for (let i = 0; i < totalChunks; i++) {
    const start = i * chunkSize;
    const blob = file.slice(start, start + chunkSize);
    const form = new FormData();
    form.append("upload_id", uploadId);
    form.append("index", String(i));
    form.append("chunk", blob, file.name);
    await api.post("/media/upload/chunk", form);
    onProgress(Math.round(((i + 1) / totalChunks) * 100));
  }

  const done = await api.post("/media/upload/complete", {
    upload_id: uploadId,
    total_chunks: totalChunks,
  });
  return done.data;
}

// Build a directly-embeddable URL for <img>/<a>. Public files need no token;
// private files carry the JWT as a query param (img/a tags can't send headers).
export function mediaUrl(file, { download = false } = {}) {
  const base = `${API}/media/${file.id}/raw`;
  const params = [];
  if (download) params.push("download=1");
  if (!file.is_public) {
    const token = localStorage.getItem("talmia_token");
    if (token) params.push(`auth=${encodeURIComponent(token)}`);
  }
  return params.length ? `${base}?${params.join("&")}` : base;
}
